import { FC, ReactElement } from "react";
import { stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";
interface Props {
  errors?: string[];
  isDirty?: boolean;
}

export const InputErrors: FC<Props> = ({ errors, isDirty }): ReactElement => {
  return (
    <>
      {isDirty !== false &&
        (errors || []).map((error: string, index: number) => (
          <p key={index} className={classNames.error}>
            · {error}
          </p>
        ))}
    </>
  );
};

const classNames = stylesheet({
  error: {
    color: Colours.red,
    fontSize: Sizes.fontSize1,
    margin: "0.35rem 0 0 0",
    fontFamily,
  },
});
